import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import { GridContainer } from "./GridContainer";
import * as Templok from "@ravalmatic/templok-engine";

export class SpecialCellHoverEffect extends Phaser.GameObjects.Container {

    private specialIcons: Phaser.GameObjects.Image [];

    constructor(scene: Phaser.Scene, duplicatedCells: {p: {c: number, r: number}, type: number}[]) {
        
        super(scene);

        this.specialIcons = [];

        for (let i = 0; i < duplicatedCells.length; i ++) {

            const c = duplicatedCells[i].p.c;
            const r = duplicatedCells[i].p.r;

            const x = GridContainer.CELL_SIZE * (c - (Templok.Engine.GRID_SIZE / 2 - .5));
            const y = GridContainer.CELL_SIZE * (r - (Templok.Engine.GRID_SIZE / 2 - .5));

            const tweenDuration = 300;

            const hRay = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "gem_0" + GameVars.selectedBlock.color + "_light");
            hRay.scaleX = 20;
            hRay.alpha = .8;
            this.add(hRay);

            this.scene.tweens.add({
                targets: hRay,
                scaleX: 1,
                alpha: .6,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: tweenDuration
            });

            const vRay = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "gem_0" + GameVars.selectedBlock.color + "_light");
            vRay.scaleY = 20;
            vRay.alpha = .8;
            this.add(vRay);

            this.scene.tweens.add({
                targets: vRay,
                scaleY: 1,
                alpha: .6,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: tweenDuration
            });

            let specialIconImgName: string;

            if (duplicatedCells[i].type === Templok.ExtraHelpType.ROTATION) {
                specialIconImgName = "symbol_turn";
            } else {
                specialIconImgName = "symbol_re-roll";
            }

            const specialIcon = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_2", specialIconImgName);
            specialIcon.visible = false;
            BoardContainer.currentInstance.specialCellTrackContainer.add(specialIcon);

            this.specialIcons.push(specialIcon);

            this.scene.time.delayedCall(tweenDuration / 2, function(): void {
                this.showSpecialIcons();
            }, [], this);  
        }
    }

    public disappear(): void {

        this.scene.tweens.add({
            targets: this.specialIcons,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600,
            onComplete: function(): void {
                for (let i = 0; i < this.specialIcons.length; i ++) {
                    this.specialIcons[i].destroy();
                }
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 600,
            onComplete: () => {
                this.destroy();
            },
            onCompleteScope: this
        });
    }

    private showSpecialIcons(): void {

        for (let i = 0; i < this.specialIcons.length; i ++) {

            // el destello radial
            const glow = new Phaser.GameObjects.Image(this.scene, this.specialIcons[i].x, this.specialIcons[i].y, "texture_atlas_1", "glow");
            glow.setScale(.6);
            BoardContainer.currentInstance.specialCellTrackContainer.add(glow);

            this.scene.tweens.add({
                targets: glow,
                scaleX: .2,
                scaleY: .2,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 200,
                onComplete: function(): void {
                    this.scene.tweens.add({
                        targets: glow,
                        scaleX: 0,
                        scaleY: 0,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 400,
                        onComplete: function(): void {
                            glow.destroy();
                        },
                        onCompleteScope: this
                    });
                },
                onCompleteScope: this
            });

            this.specialIcons[i].visible = true;

            BoardContainer.currentInstance.specialCellTrackContainer.bringToTop(this.specialIcons[i]);
        } 
    }
}
